// extracted by mini-css-extract-plugin
export default {"uploadModal":"VideoTextTalkInput_uploadModal__kQN1i"};